var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPenPathQuotaTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4784_84148)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 29,
    height: 29,
    rx: 5,
    fill: "#128B9B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1213 10.8787L26.7071 9.29289C27.0976 8.90237 27.0976 8.26756 26.7071 7.87804L24.1213 5.29289C23.7308 4.90237 23.0959 4.90237 22.7071 5.29289L21.1213 6.87868L24.7071 10.4645L25.1213 10.8787ZM16.7071 18.7071C16.3166 18.3166 15.6834 18.3166 15.2929 18.7071L10.2929 23.7071C10.1054 23.8946 10 24.1489 10 24.4142V26.8284C10 27.2205 10.4477 27.5 10.7071 27.5H13.1213C13.3166 27.5 13.5304 27.3871 13.7071 27.2071L18.7071 22.2071C19.0976 21.8166 19.0976 21.1819 18.7071 20.7924L16.7071 18.7071Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7071 9.29289L24.1213 7.70711C23.7308 7.31658 23.0959 7.31658 22.7071 7.70711L21.1213 9.29289C20.7308 9.68342 20.7308 10.3166 21.1213 10.7071L22.7071 12.2929C23.0976 12.6834 23.7308 12.6834 24.1213 12.2929L25.7071 10.7071C26.0976 10.3166 26.0976 9.68342 25.7071 9.29289Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4784_84148",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4784_84148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4784_84148",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPenPathQuotaTable);
export default __webpack_public_path__ + "static/media/add-pen-Path-quota-table.fdc9db6b7606dd1b26853678bf64ee5a.svg";
export { ForwardRef as ReactComponent };